module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "last"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ST"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Last Plane to Heaven: A Love Story")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "CEP"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("I went to Outer Mongolia for the first time in 1990. Parts of this story are true, and happened to me then. Most of it is made up. You decide what to believe.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Nichols tried to light a cigarette, one of those fucking Paki horse turds. “Know why God made the ’stans?” His palm cupped the flame against the steppe winds. Must’ve been burning his fingers, but if he didn’t care, I sure as hell didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hell if I know.” The dust out here was like to drive me to tears, Oakley wraparounds or not. That shit got in the cracks of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("everything.")]), _vm._v(" My shoulders ached like a son of a bitch, too, after standing around all day with a SAM tube on my shoulder. I shifted the Stinger, listening for that familiar tubercular roar of old Sov-built engines. The Antonov was overdue.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He got his horse turd lit, took a long, coughing drag. “Shit’s got to come out somewhere, that’s why.” A gap-toothed grin, where a couple of Uzbek hash merchants had kicked him hard a few months back. He’d eaten their ears a bit later. “The ’stans are the asshole of the Earth. America, we’re the tits. Land of milk and honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Tits was right, I thought. But honey? Something chattered out there. I scanned the northeast over the hardpan. Nothing but scattered grass and endless identical miles, while the dust was making a silver-brown hash of the Gobi sky.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No sign of the Antonov.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Maybe I’d heard the windsock snapping.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ain’t you gonna ask?” he said, after another deep drag.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ask what?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Where the world’s pussy is?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I knew better than to walk into that one, so I just returned his grin. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I")]), _vm._v(" still had all my teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Aw, fuck it.” Nichols pitched the flaring cigarette into the wind. It bounced past the wheel ruts on the desert floor then vanished into dust, leaving a flare on my vision.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t do that shit, man.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Snipers?” His laugh was as harsh as his cigarettes. “Here? Hiding behind what? The sky, maybe. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You’re")]), _vm._v(" the pussy, Allen. Pussy of the world, right here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Snipers my ass.” I was less confident than him on that. Not much less, but a careful troopie lived to see chow call. “Only you can prevent forest fires.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Smokey the fucking Mongolian bear!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then the Antonov was overhead, growling out of the dust in a reek of fuel and old metal, the pilot looking for the windsock.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("Say what you want about Sov technology, the shit they built just keeps working. That old An-17 had probably been flying, badly, when I was playing kill-the-ragheads in the Oregon forests as a kid. It was still flying badly now. As the fly-guys say, any landing you walk away from is a good landing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The south Gobi is a series of very shallow valleys bordered by low ridges a half dozen klicks apart. The desert is sort of like prairie gone bad, with stubby, dried grasses, the odd flower, and a hell of a lot of gravel. If you look up and down the valleys, you can see the edge of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The strip here was a windsock stuck in the hardpan. Every now and then someone got tired of the planes bouncing in their wheel ruts and replanted the windsock fifty yards farther east. There was an archaeology of occupation and warfare written in the tracks of old landing gear.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Most of the Westerners in the ’stans were like Nichols. Smart enough, and stone killers in a firefight or on a silent op, but pretty much baboons otherwise. A million years ago they would have been the big apes throwing shit from the trees. Now they’re out here capping ragheads and steppe weasels. I guess that beats breaking elbows for money back home.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I tried explaining Temujin to Nichols one time as we were burning some idealistic kids out of an eight-hundred-year-old temple. Blue-faced demons crisped to winter ash while their ammo cooked off in a funeral cantata. He’d just laughed and told me to go back to college if I didn’t like it here.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s a beautiful country, Mongolia. All the ’stans are beautiful in their way. Xin Jiang, too. Nichols was wrong about this being the asshole of the earth. God "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("had")]), _vm._v(" made these countries, all right, to remind us all how damned tough the world was. And how beauty could rise from the hard choices and broken lives.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then God in His infinite wisdom had chosen to people these lands with some of the toughest sons of bitches to ever draw breath. These people could hold a grudge for a thousand years and didn’t mind eating bullets to avenge their honor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fuck you very much, God, for Your beauty and Your terror.")]), _vm._v(" Not to mention Sov aircraft to dust us off to the brothels of Ulan Bator every once in a while. Nothing expressed God’s love for His world like warm North Korean beer and elderly Chechen hookers.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Yo, Allen, get in here!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was Korunov. His head bobbed out the weathered orange door of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" that served as our HQ. Ex-KGB counterintel guy. He’d spent a lot of time at the USA-Canada Institute, back when that was still cranking, and spoke with the damnedest accent. His voice was part Alabama cornpone and part Ukrainian street hustler, squeaking out of a two-hundred-kilo butterball.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hell, he must have been thin once. Nobody starts out life that kind of fat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Korunov considered himself a man of the world. He was also the paymaster of our little unit, so when he yo’d, I ho’d.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols and Korunov were crowded into the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" along with Batugan—our Mongolian controller back in UB and the only man to get off the Antonov upon arrival. As always, the pilot remained on board to keep his points hot. Plus Hannaday was there. He was an Agency cowboy I’d last seen on the wrong end of a Glock in Kandahar two years earlier. Whipcord thin, still wearing the same damned Armani suit.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("How the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("fuck")]), _vm._v(" had that spook gotten into the camp without me seeing him? My legs still ached whenever it got chilly. I briefly considered firing off my Stinger inside the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger,")]), _vm._v(" just punching the warhead into Hannaday’s chest, but that would have pretty much toasted us all.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Stow it,” growled Korunov. Two hundred kilos or not, that man could and did snap necks.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("he")]), _vm._v(" doing here?” I wouldn’t meet Hannaday’s gaze. “He’s worse trouble than the insurgency.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Batugan gave me his oily smile. I don’t think he had any other kind, truth be told. “Mr. Hannaday has bought out your contracts.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“My contract wasn’t up for sale to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Korunov got too close to me. “Sit. Listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I laid the Stinger against the tent walls, loosed the holster on my Smitty, then pulled up one of those little orange Mongolian stools. I never took my eyes off Hannaday’s hands. “Listening, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sir")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You should be—” Batugan began, but Korunov interrupted. “Not your show anymore, Genghis.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The fat man’s voice dropped, sympathy or perhaps an attempt at camaraderie, as he turned to me. “Our financial backers have pulled out. Batugan flew here to cut us loose.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Cut us loose here? We were a training cadre. They brought in kids with attitude, we ran them through some high-fatality training, they pulled them back out to go fight the bad guys. There "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("was")]), _vm._v(" no way out but by plane. That way the kids wouldn’t run off. And no one ever came around asking inconvenient questions about the row of graves on the far side of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" camp.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("You could make it out by truck. Damned long haul, though, and you had to pack along enough water and fuel. Didn’t matter anyhow. There weren’t any trucks in camp right now, just a couple of old Chinese-surplus BJC jeeps.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Not a lot of landmarks in the south Gobi. Sure as hell no roads.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So?” I wasn’t a decision maker. Why were they telling me?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Korunov chose his words carefully. “Mr. Hannaday here is bankrolling airfare back to Los Angeles or Frankfurt, plus a generous kill fee.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I finally met Hannaday’s eyes. They gleamed that same eerie blue as back in Kandahar. His smile died there.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t care what he wants. I’d rather walk than take his money.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s why we need you, Mr. Allen,” Hannaday said. “The unit listens to you.” There was something wrong with his voice—it grated, almost fading out.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With that clue, even in the shadowed "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger,")]), _vm._v(" I could make out a scar seaming his throat. It was a glossy trail just above the crisp Windsor knot of his tie. I’d lost my best knife in that throat, the day he shot me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You don’t talk right, I don’t walk right.” Which was why I trained instead of killed these days. “I think we’ve done enough for each other.” I stood, grabbed my missile rack.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Allen.” It was Korunov.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I owed him. Lots. I stopped to listen. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We don’t have seats on the plane. None of us. Not without Mr. Hannaday.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I had eleven guys outside who were real good at knocking over airplanes, Nichols chief among them. But I also had eleven guys outside who weren’t going to be happy about hiking out of the south Gobi.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We got return bonds, Sergei,” I told Korunov softly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He shrugged, his face impassive. “If we were elsewhere, we could cash them. Mr. Hannaday bought the air transport contract from Batugan before he bought our paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I had my Smitty out and two rounds in Batugan, one in each thigh. The Mongolian fell off his stool sobbing, curling to clutch at his legs. Neither Hannaday nor Korunov moved. Neither one drew down on me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So I am worth something to you, you son of a bitch.” Careful not to point the weapon at Hannaday, I holstered the pistol. “What the fuck do you want, airplane man?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Like you, I’m—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’ll never be like me, you fucking Langley suit.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Please,” Hannaday said. One hand stroked the knot of his tie. I hoped like hell the scar ached as bad as my legs. “Fort Meade. And, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("like you,")]), _vm._v(" I’m a contractor now.” Without looking, he leaned over slightly and slapped Batugan hard. The Mongolian quieted his blubbering.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That drew a reluctant laugh out of me. “Big spookery all get outsourced to India?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Pakistan, actually. In the name of funding and plausible deniability.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fuck yeah. What’s your point?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We’re going to bring in a special subject. We need your team to play like Ukrainian mercs for about a week. Ride the subject hard, put them in some real fear, then let them be extracted.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Who was he kidding, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("extracted")]), _vm._v("? I knew what that signified. “What, Delta Force falls out of the sky and caps us all? No thanks.” As if this bunch of multinational nimrods could be Ukrainians. Korunov actually was, the real McCoyovich. After the fat man, Nichols with his Paki cigarettes was the safest and sanest of the bunch. There was a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("reason")]), _vm._v(" our little crowd wasn’t out eating snakes on the front line.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No-risk deal,” said Hannaday impassively.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That deal ain’t been written yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He folded his hands in his lap, a deliberate gesture straight out of interrogation training. “I’ll be sitting here with you the whole time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Well, I could always cap "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("him")]), _vm._v(" when the shit went south. Because a situation like he wanted to set up would without question run for the border before it was all over with.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And it ain’t like I was walking out of here.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fuck you very much,” I told Korunov. “I guess we’re playing. I’ll go get the boys fired up.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What are you going to tell them?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Just some fucking lies. I got a million of ’em.” I grabbed my Stinger rack, waved it at Batugan. “You might want to slap a Band-Aid on Ming the Merciless over there before he bleeds out.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t need him anymore,” said Hannaday.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t let the door hit me on the ass. Paymaster and contract man could gas all they wanted. I’d chosen my poison.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("It took a little while to get a camp meeting together. Beier, the South African, was somewhere sleeping off a three-day bender, while the Belgians were off dust-wrestling and greasing each other down. Those two boys didn’t much like being interrupted at play, so I sent Nichols after them. I rousted the rest of the crew to find Beier.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We wound up in the kitchen "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(". It was too damned windy to talk outside. I didn’t want to be near the Antonov—for several reasons—nor near Hannaday and Korunov. The Belgians were madder than hell and Beier was propped up against a stack of North Korean beer beneath a line of curing mutton fatback that kept dripping on him. There was a potbellied stove, thankfully cold, stacks of MREs and Chinese canned goods, and us.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I picked my nails with a Bowie knife till everyone quieted down. That was so fucking theatrical it made me want to puke, but this was the kind of shit that worked on these boys. Visible weapons and getting straight to the point.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Listen up, geniuses. We’re stewed and screwed here. Korunov’s been forced to accept a transfer of our contracts. We’re getting out soon, but there’s one more task.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They groaned and cursed in seven languages.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah,” I said. “I know. We got to run a fake hostage situation with a drop-in, pretend to be Ukrainians.” Commonwealth of Independent States political bullshit. My guess was we’d be labeled later as Chechens. The ex-Sovs saw them in every shadow the way Americans saw Arabs. “So if you’ve got a Slavic accent, start using it. If you don’t got one, start practicing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What happens if we say no?” It was Nichols, speaking quietly for a change. Somehow everyone was suddenly listening.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re free to walk home any time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We got return bonds.” That was Echeverria, the ETA guy for whom all of Europe had gotten too hot. I didn’t figure anybody Hannaday swung in here would cop to a Basque accent.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah. If we can cash ’em. You see an ATM around here, Etchy?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols again: “So what do we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Put ’em through the usual course, just don’t kill ’em. Scare the hell out of whoever this is. And…” I glanced at Beier, who appeared to be snoring. “… they keep all their bits and pieces attached and intact.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I figured the marching orders would change between now and then, several times most likely, but I also figured the bits and pieces part would still apply.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What happens at the end?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“An extraction.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They all got real quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Staged, boys. And we’ll know they’re coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I fire no blanks,” said one of the Belgians. Everybody laughed except me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Think about it. Unless you can grow a truck under you or sprout wings and fly, we’re pretty much stuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Knock over the Antonov right now,” said Nichols. “And split.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nope.” I pointed the knife at him. “First off, a couple of stray rounds and that plane’s toast. You know what a piece of shit it is. Second off, they don’t keep no fucking maps on that thing. Three or four of us know enough to get it flying. None of us know the terrain. Something happens to the pilot, you want to navigate the Gobi from the air by eyeball and dead reckoning? Third, I’d bet money Hannaday’s got surprises inside that plane right now, just in case any "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("one")]), _vm._v(" of us is a smartass.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hannaday?” Nichols didn’t miss much, and he’d heard a lot of my stories.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yep. Mr. Congeniality himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And you’re going for this?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Hell no,")]), _vm._v(" I wanted to say. What I did say was, “You got a better idea?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No one had an answer for that question. After a full minute of silence, I put my knife away.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("An hour later Hannaday had me and Nichols on the plane trolling for new fish from five hundred feet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Antonov 17’s a funny bird. Looks almost like a kid’s drawing of an aircraft, twin props, high wing. Not that big, and a slow fucker to boot, but they really did keep flying forever. The seats had been designed for Chinese grandmothers, not American mercs with incipient butt spread. Tiny aluminum rails with webbing between, idiot cousin to the common lawn chair. Air Munchkin. How the hell a Sov platoon in full kit ever fit inside these cans I couldn’t imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t bother with the seat belt.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday hadn’t relieved me of my Smitty, though the Stinger rack was back at camp. Nichols was sucking down another of those Paki horse turds as he fondled the barrel of his Mossberg jungle gun—a 40mm automatic shotgun that should have had Hannaday sweating.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Gobi lumbered along outside the oval windows, low and slow. The pilot was looking for something.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Someone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Curiosity finally got the better of my common sense. “We’re doing a pickup out "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("here")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Special delivery,” said Hannaday, surprising me. He wasn’t much given to sharing information.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We’re a thousand klicks from "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("anything")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And that, my gimpy friend, is precisely why we’re here.” His eyes narrowed to steel-gray slits. There was another reason he was here, as opposed to somewhere else. Hannaday thought he could run me. He’d done it before.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He was doing it now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fuck him. I didn’t want to die of old age walking out of the south Gobi, but fuck him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then the intercom crackled to life. The pilot said something fast and tonal—Cantonese, I thought, not that I could follow it. The Antonov banked hard and picked up speed as the engines coughed a bloom of black smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Whatever it was we were looking for, we’d found it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday just smiled. “Ready for some ladder work?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Ladder work? Out here?")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("And damn me if we didn’t bounce to a landing somewhere not much different from anywhere else. There were cloud shadows on the ground, and a small herd of yaks in the distance. That meant Mongolians somewhere—their animals had a wide range, but they weren’t left completely unattended.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Out,” said Hannaday. “Open the cargo bay.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols popped the door seals in a wash of fuel reek, then dropped the aluminum boarding ladder. I made my way carefully after him, one step at a time on my bad legs.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It stank outside, of fire and something nasty-chemical. Hydrazine? Nichols was banging on the cargo hatch as I bent to look under the plane, scanning for the source of the reek.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I found it. “Holy fuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols was distracted. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday dropped down between us and knelt. “Nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The thing was half rounded, like a stubby bullet, and blackened all to hell. It sat on the flat side. Smoke curled off, dancing in the dry grass around the … the … ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Soyuz TMA-3 landing capsule,” said Hannaday. “Get the ladder. And stay the hell away from the bottom. There’s a gamma-ray emitter down there that will fry your nuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols had found this weird folding ladder, sort of halfway between a painter’s stepladder and a scaffold. He shouldered the Mossberg and dragged the ladder toward the Soyuz with that shiny-eyed focus I normally associated with an impending massacre.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Soyuz")]), _vm._v(". We were dusting off a fucking spaceman. “Somebody’s looking for this.” I glanced at the sky for the fleet of Russian Hinds that must surely be in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday laughed again. “Yeah, a couple of thousand klicks from here. Get the camo netting out of the hold, Allen.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I got the camo netting.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("Up close the capsule had that brutal precision so typical of Sov high tech. It could have been whittled from stone, then ground off. Reentry had done the thing no favors either. The surface was covered with burned streaks and pits. A round hatch stood open near the nose, from which lines of a parachute stretched out some few dozen yards across the grass. The smoking ground testified to the retro rockets that had soft-landed the capsule.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At that range the smell was worse, hydrazine and baked metal and some weird ozone thing. It made me wish for a breather mask. I dropped the mound of camo netting and sat on it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday took the ladder and set it up against the blunt cone. The scaffold part fit across the top. Of course it did, I thought. He went straight for a little opening, pulled out something I would swear was a key, and went to work on the nose.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Help me out, boys,” he said and he wrestled open a hatch.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Of course I didn’t shoot him. The Antonov pilot would have taken off without us.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spy guy fished out a real live astronaut, someone small in a jumpsuit who couldn’t stand on his own feet. Nichols and I got the guy down the ladder, then Nichols took off for the Antonov with the space traveler in a fireman’s carry while Hannaday and I spread out the netting and covered the capsule. He didn’t bother to retrieve his ladder.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nice one.” I coughed through the reek. “You’re running a scam of epic proportions. I assume we’re nixing satellite surveillance here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday grinned around the curve of the capsule. “Everybody’s got to make a living, Allen.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When I pulled myself back up the Antonov’s ladder, I found Nichols up front by the locked pilot’s door, staring back down the narrow aisle. He was pale and sweating.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What?” I said. “You find Elvis there?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She’s a girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I went and looked. Our spaceman "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("was")]), _vm._v(" a girl, not more than fifteen, eyes bloodshot from reentry gees, barely moving even as she stared at us. Blue-black skin, shaved head.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A girl.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Who’d dropped out of the Central Asian sky in a Russian spaceship.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kids on the International Space Station? Not fucking likely. Not in this lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hannaday,” I breathed, “who the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("fuck")]), _vm._v(" is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("The Antonov lumbered back to camp. Nichols sat in the back of the plane with his shotgun, watching the kid and cursing in an extended monotone, mostly Russian. I perched in a chair at the front of the cabin opposite Hannaday.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Who is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He had the familiar old Hannaday I’m-in-charge-here smile. “No one you’ll ever know, Allen.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Bullshit. We’re supposed to run her through live-fire countersecurity drills for a week? We’ll "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" her happy ass before we’re through.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was an unfortunate choice of words. Hannaday’s smile just tightened a little. “Don’t break off no bits and pieces. Not "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("any")]), _vm._v(" of her bits.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We were both thinking of Beier then, the man who would do anything to anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s not what I’m talking about and you know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He shrugged. “Speak Russian for a week, push her around, scare her, then let her be dusted off. Don’t put any bullets or body parts into her, you’ll be fine. What could be easier?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My legs ached where he had shot me. “Who "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("is")]), _vm._v(" she?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ah-ah.” I swear to God he wagged his finger at me. “That would be telling.”")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("On landing Nichols bolted from the plane like he had the Tehran trots. That meant the girl’s presence would be known to everyone in five minutes, tops. As if I could control that anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday looked at me. “I don’t guess you’re going to carry her down the ladder, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Got these old war wounds in my legs.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He smiled, gathered the girl close to his chest, and made it down the ladder himself. Looking down from the door I seriously considered popping a cap in his crown, just as a public service. But then he’d drop that poor kid and where would we be?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Within moments there was a swirl of mercs, mostly barking in Russian or English with Peter Ustinov accents. Hannaday gave up the girl to them, shouting back in Russian about security and escape, then returned to the plane as I made it to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Be good,” he told me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fuck you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Whatever gets you through the night.” He set his hands on the boarding ladder, then stopped. “Oh … Allen…?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My hand strayed to the Smitty. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Do take good care of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("They poured Evian water and Mongolian vodka down that poor kid until she sputtered to life. Then the Belgians harangued her in an incomprehensible mix of Flemish and Russian for a while before dragging her outside. She wasn’t up to running around our improvised training course, so they hauled her to the firing range, Korunov trailing behind like a loose grenade.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oh good,")]), _vm._v(" I thought, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("get the kid drunk then make her shoot.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Better than shooting at her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols pushed me back into the kitchen tent, where Beier was still sleeping standing up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He’s crazy.” Nichols’s voice was a strident hiss.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Plane’s gone. You don’t have to whisper.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We run her through the course, we’ll kill her.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We’ve got a forty percent fatality rate as it is. Never bothered you before.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols looked around, taking a long, hard stare at Beier. The South African was snoring gently, mumbling on each exhalation. “She’s a fucking "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("kid,")]), _vm._v("” he said after a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He knew something, I realized. Nichols knew something about this. “You’re inside this job, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No!” Nichols snapped. He glanced at Beier again, then down at the greasy, carpeted floor of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger.")]), _vm._v(" “It’s … look, I’ve never…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah?” My voice was getting harder than I wanted it to. I couldn’t lose control with Nichols. He was the closest thing I had to a friend in this chickenshit outfit, and God only knew I needed my friends right now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I never told anyone this,” Nichols said, still talking to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah?” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Get to the fucking point.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You know I was in Baku when the Barclay’s bombing went off, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Baku?")]), _vm._v(" I couldn’t imagine what the hell Azerbaijan had to do with this. “No, actually, I didn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He met my eyes. It was the first time I’d ever seen Nichols frightened. I could smell it on him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“About three minutes before the bomb went off, I got a sudden headache. Like … like … a stab wound.” Deep breath, his chest shaking. “So I went outside for a smoke. Headache didn’t get better until I walked around the block. I headed back for my detail and…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Headache stabbed me when I got near the building. I turned around, walked away again. Headache left, bomb went off. Allen, if I’d stayed where I was supposed to be, I’d be dead right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Both looney and tunes in one sweet package. He was picking a hell of a time to crack up. “Okay…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No.” He was shaking now. “Listen, I’m not crazy. Three, four times in my life I’ve had that. Once as a kid, when the rattler got my brother instead of me. In Baku, with the bombing. Again in Mosul last year, right before the White Shrine Massacre.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My neck was starting to prickle. “And?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That girl gives me a headache. Only this one’s a bullet, not a stabbing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Great. Terrific. Psychic-psycho mercenaries in the Gobi desert. Film at fucking eleven.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I should have popped that damned cap on Hannaday.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Go get some sleep,” I told him, then summoned up my best soldier-Russian and went out to see how our spacegirl was doing with an AK-47 in her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("One of the Belgians, Henri VerMeirssen, pulled me out into the desert after dinner. “We must talk, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("mijn vriend")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I was really looking forward to more headache stories. I went with him, though. Henri didn’t usually talk much, not to me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Okay,” I said about forty yards from the grave rows.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nichols, he has "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("een spook gezien.")]), _vm._v(" Eh, seen a ghost, you would say.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I stopped, looked Henri in the eyes. Even in the dusk, I could see the cold glint. He smelled faintly of rosewater and gunpowder, just like he always did. He wasn’t laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I do not mean a corpse, a dead person. I mean to say, Nichols is very frightened. I have never seen him frightened. Where did Korunov send you on the Antonov?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spacegirl had been wearing a Russian flight suit. Without a name tag. She hadn’t said a word since she’d gotten here. She’d fired her weapon with drastic incompetence, then collapsed into deep sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So far our program of intimidation wasn’t working. But these guys were smart. Dumb mercs were dead mercs. They knew what a flight suit was.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She dropped out of the sky, Henri.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The recovery pod of some kind, no?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You could say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And so what is it which frightens Nichols? Becque and I, we are to think the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("biologische oorlogsvoering")]), _vm._v(". Eh, the, ah, biologic warfare. Is she a virus host, Allen?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What he was really asking was whether I’d killed us all already.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The answer to that was probably yes, but not the way he meant it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No.” Hannaday would have been dooming himself. Hell, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("he’d")]), _vm._v(" pulled her out of the capsule. “Not a biological problem. I think she is a political problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nichols, he is not scared of the politics.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No. But every man has shadows in his soul, my friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He is scared of girls?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You could say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Eh.” Henri turned back, took a step, paused.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I waited for it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Becque…” His lover, partner, squad buddy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was time to force a smile. “Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Becque, he is saying the girl makes him the headache. Becque has never had the headache before.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Perhaps he should take an aspirin.” Could this really be a biological? Some sort of timed exposure? With Hannaday getting out fast enough to take a treatment, maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He also is saying she talks to him, though her lips do not move.” Henri shrugged. “But Becque he has been "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("gek")]), _vm._v(" these many years.” He walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I wondered what "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("gek")]), _vm._v(" meant, exactly. It wasn’t hard to guess. I stood for a while in the descending chill, watching the hard light of the stars and wondering what precisely this girl had been doing in orbit.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("The land spoke to me. Snow leopards roared from the distant peaks to the south, while lammergeyers circled overhead. Even the bellowing of the yaks carried over the miles and valleys. Together they made a voice.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You. Airplane man.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I tried to answer, but my lips were bound together with stinging sutures.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Do not let them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then a knife of ice slid behind my ear to fill the space between brain and mind.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Airplane man,” the land whispered as Nichols screamed from a distant place.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Get up. Now.” It was Becque, looking scared.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I looked around the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" I shared with Nichols. Had he been screaming?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Perhaps, but he was gone now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Aren’t you on perimeter?” I asked Becque.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oui,")]), _vm._v(" but your Nichols he has walked to the desert and he is not returning.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My TAG said it was just after oh three hundred hours. “When?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The midnight, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("peut-être")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Three fucking hours, and you come get me "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("now")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We have no SOP about the desert.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Right.” I shrugged into my stinking cammies, belted on the Smitty, and grabbed my Stinger rack. “Who’s got perimeter right now?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Moi.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fuck me. There wasn’t any point in yelling at him. Besides, Henri had said Becque was getting headaches too. “Show me where he went.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The dew, such as it was, was already down. There’s a hell of a lot of starlight out in the Gobi. Nichols’s trail was clear enough. I shouldered my Stinger and followed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The night smelled of flowers and a flinty scent off the distant hills. Dinosaur bones out here everywhere, so I’d been told. I could almost imagine one of them lumbering by. I’d rather imagine Nichols lumbering by.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The trail headed due south. I continued to follow, wondering why the hell the camp gimp was out stalking around in the darkness. There were snow leopards in those hills, for God’s sake. Worse than fucking cougars.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t trust anyone else to bring Nichols to safety.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Something rumbled in the darkness ahead of me. I brought the Stinger rack to port arms. “Nichols?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The breeze swirled, rustling the low-stem grass clumps and kicking up damp dust. There was another noise, a sort of scraping.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Which was weird as hell, because I could see miles ahead of me, and there was nothing out there.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I walked toward the noise.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nichols.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When the shambling thing popped up out of the grass, it startled me so badly I fired the Stinger. Damned backblast set my sleeve smoldering and started a grass fire. My head rang like a son of a bitch. Slapping holster for the Smitty, I charged toward it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There was a spread of fur and guts and shattered ribs, limbs blown apart from the body. Blood, shit, and propellant battled in my nostrils. I could see that something was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I reluctantly bent to touch the fur.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Grass. Wrapped around ordinary skin.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The head lay on its crown, smashed to a broken egg by the missile. I used the edge of the empty Stinger rack to tip it face-upward.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Who for some fucking reason had been wound around with a huge amount of desert grass woven together so that he’d looked like a giant, vegetable bigfoot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A giant, dead, vegetable bigfoot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“God damned mother fucker!” I screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When I turned, I couldn’t see the camp.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("I ran until my legs gave out. I’d lost the Stinger rack somewhere, but my Smitty still banged against my thigh as I stumbled. I reeked of propellant, blood, my own sweat. The sky above me glittered like a city in the heavens, New York ascended to the country of the saints.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Oh, God, what had I done?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then I was down in the grass, too, clawing at the loose stems growing clumped from the gravel floor of the desert. They seemed warm to my touch. The plants crinkled in my hands, bending and snapping.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Was this what Nichols had felt?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nichols")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What the hell had happened to him? To me? To the sky?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("How had I shot a man with a Stinger, I wondered. I remembered the cold knife of ice. And something was wrong with the stars.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Something was wrong, all right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I laid the Smitty on my chest, pointing the barrel at my right foot. The weapon was cold and heavy. If I shot my toes off out here, I’d likely bleed to death before help arrived. Assuming help ever did arrive. But I couldn’t run any farther—the scarred muscles of my thighs were already knotted beyond pain.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Item: I could not find or see the camp, even though I had a straight backtrail.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Item: I didn’t believe a Stinger would kill a man at point-blank range, not that way. It was an antiaircraft missile, and the warhead hadn’t exploded.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Item: One by one, my boys were getting those headaches.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I realized that I was dreaming. That space bitch of Hannaday’s was doing this to me. My finger rested on the trigger of my pistol.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If I was dreaming, I should just be able to wake up. My mind was my own.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Item: The trigger was oily and chill as it should have been. I could even feel the familiar scarring on the curved metal. Had I ever dreamed this real?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Item: I was dead out here anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But this was going to hurt like fuck, and I hated the thought of dying stupid.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I gritted my teeth and pulled the trigger.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Get up. Now.” It was Becque, looking scared.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I looked around the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" I shared with Nichols. Had he been screaming?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fuck no, I’d been screaming. I threw the blankets back, looking for my bloody, shattered foot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nothing but a smooth black boot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Where the hell is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nichols,” said Becque. “You know already?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I had the Smitty out then, aimed at Becque’s face. “Listen to me, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ami")]), _vm._v(".” Did spacegirl speak French? Did it matter, inside my dreams? "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Quel est le deuxième prénom de Henri?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Becque put his hands up, backing slowly toward the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v("’s door. “Hey, Allen. Easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Respondez-vous, Becque.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Allen…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I shot him in the face.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Get up. Now.” It was Becque, looking scared.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I rolled out of my cot, snap-drawing the Smitty. He ducked out, the orange wooden door slamming hard. I was up and after him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Outside the sky blazed like Manhattan in heaven. The camp was gone, just my "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" in the middle of the Gobi. No Becque, either.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dreamland again, then. But I had some authority in this version.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Come out,” I said. “Get out here and talk to me.” Smitty braced, I turned a slow circle.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No one but me and the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I imagined the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" gone, and on my next circuit it was. I was alone in the Gobi under a blazing sky.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The sky … ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The stars were moving. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fucking dreamland.")]), _vm._v(" They swirled, coiled flaming snakes on the prowl, making spirals that would suck down my soul if I let them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Stop it,” I shouted, aiming the Smitty upward. “I can’t give you what you want if you don’t tell me what it is!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The spirals flowed into a face. A shaggy face.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No, not shag. Grass.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols’s eyes winked down from high above. His voice was on the wind, made of the noises of a thousand miles of desert.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Allen.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I aimed toward one sparkling, swirling eye. “It’s you, isn’t it? Spacegirl.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The eye in my sights winked with a noise like a storm over water.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What were you doing in orbit?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Dreaming real,” said the night-hunting birds.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dreaming real. She was black, blacker than anyone I’d ever met. Radiation burns?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dreaming. Abos, from Australia. “Dreamtime, not dreamland,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Different in the sky,” the snow leopards coughed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t believe a fucking word of it. “Wake up!” I shouted, slamming the butt of the Smitty into Hannaday’s scars on my thighs.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Get up. Now.” It was Becque, looking scared.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’d brought myself out of it this time, in control. I hoped. One hand on the Smitty, I said, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Quel est le deuxième prénom de Henri?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Becque’s fear shifted to disgust. “Henri, he does not have a middle name, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("bibelot")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fuck you, too. What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nichols, he is outside screaming about God’s iron knives.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah. Get that girl out of wherever she is, and awake.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The door banged shut. I grabbed my Stinger rack—still loaded, I was pleased to notice—then stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What good was a weapon going to do me?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The real question was whether this girl was Hannaday’s agent, his tool, or his prize. And I didn’t believe that even Hannaday could make things happen in orbit. She had to be stolen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The real weapon was in the head, like always. Hers was just a little more to the point than most of ours.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2-NOSPACE"
  }, [_vm._v("Outside, Beier was sitting on Nichols’s chest. They were both breathing hard, and there was some blood. Hard to tell in the starlit dark.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The sky was normal.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Thank God.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spacegirl was in front of me, dangled between Becque and Etchy. She smiled softly. The smile of someone who expects to die.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re abo,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Anangu,” she replied, in a soft voice that reeked of Oxford and MI-5. Her first word to us.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Anangu. With power over the Dreamtime.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She shrugged within her captors’ grip.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What were you doing in orbit?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Another shrug.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You belong to Hannaday now. You know Hannaday?” I waited, but she didn’t respond. “He owns all of us. He owns our contracts, he owns our airplane, and he owns our every waking moment. But…” I stared hard into her eyes. “He’s never going to own our fucking dreams.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her smile faded.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So. Can you dream him real, the way you’ve been dreaming us? Can you put the knives in his head?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Shrug.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Listen to me.” I leaned in close, almost touching her face. “If you want to walk away, to live a life of your own and be free of him, you’d better find that shit inside you. Because when Hannaday comes back with the last plane, if we don’t smoke him, he’s going to smoke us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Allen.” Etchy’s voice was soft. Careful.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah?” I didn’t break eye contact with spacegirl.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You are more crazy than Nichols.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Shut up,” I suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spacegirl found her smile again.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("We gave up all pretense of following Hannaday’s plan. Instead we sat around and worked up scenarios for taking the Antonov without killing the pilot. For responding to a Delta-force type extraction attempt on the spacegirl. For long-term escape and evasion.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Every bit of it hopeless. Every one of us knew that in our bones. They all stayed away from me except for Nichols. The rest of the boys thought I was crazy, or crazier. Nichols didn’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spacegirl just smiled, ate our chow, and slept a lot. I hoped like hell she was cooking up a Dreamtime whammy for Hannaday.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Four days later something overflew us very, very high. It left a contrail like a string of butt beads.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Aurora,” Nichols said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The biggest, baddest, blackest spy plane in the world. I knew who they were looking for.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Two hours after that an F-117 screamed past. In the middle of the Gobi, no less. He had to have scrambled out of Almaty. I didn’t have my Stinger rack handy, and it wouldn’t have gotten a lock on that fucker anyway, but I loosed a few Smitty rounds after it. Not that the flyboy would ever give a shit.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nichols laughed. “Damn, I wish we had some real SAMs.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Pretty soon you’re going to wish we had some spetsnaz troopers. Wait till his friends come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We got spacegirl in the kitchen "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger,")]), _vm._v(" surrounded by all eleven of us armed to the teeth and beyond, except Korunov who was standing by her with water and a first-aid kit. If we had to start shooting, though, we were already lost.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She just fell asleep with that little smile on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("The first Blackhawk helicopter arrived at dawn the next day. It roared about a hundred yards overhead, then arrowed on across the Gobi. When it crashed near the horizon, I stepped inside the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ger")]), _vm._v(" to check on spacegirl.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She was still asleep, but her smile was so wide she was practically grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Blackhawk’s course had never changed once it had passed us.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jesus, I realized, spacegirl could have killed us all.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Three more followed minutes later, juking and sweeping like they expected hostile fire. I had my Stinger rack out and ready, but I wasn’t feeling like much of an optimist. They shot right past the camp, heading for an imaginary LZ a kilometer east. Two of the choppers got tangled coming in. The third one belly-flopped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t want to see her face this time. Even though those troopies out there would have killed us all, this was too much.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We settled in to wait for Hannaday. He was smart enough not to keep throwing hardware at us. He’d come in.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But he took his sweet time.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("“Get up. Now.” It was Becque, looking scared.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You don’t need him, Anangu,” I said. I grabbed my Stinger rack and stepped outside into the blazing stars of the Dreamtime. Becque was already gone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Okay, clear enough. She’d handled Delta Force, but this was up to me. Hannaday was my demon.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fine. I had some fucking sense of the rules now. Even in Dreamtime my legs ached. I owed him here as much as anywhere in real life.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Antonov lumbered past at tree-trimming altitude. The helicopters still burned in the distance. Nice trick that, after all these hours. I trotted toward the windsock where Hannaday’s pilot would put it down.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Antonov flopped in like a child’s nightmare of flight, bouncing hard on the ruts. First I put my Stinger into the starboard engine. She was already taxiing when the missile hit, but the nacelle exploded, taking that landing gear with it. The noise was horrendous.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I kept walking through the reek of rocket fuel and airplane fire.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday was out in seconds, his Armani coat torn at the seams, an Uzi in his hand. “Allen, you crazy fucker!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Smitty got him in the right kneecap.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He went down, Uzi braced.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Water,” I told the night in the voice of a thousand flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then I walked into the damp spray of his trigger pull.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What the…?” Hannaday threw the Uzi at me. I swatted it away, knelt down next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hey, fucker.” I put my pistol at the back of his left knee and shot him again. “How’s it feel?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hannaday was sobbing now, begging in words that came so lumpy I couldn’t understand anything but the tone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I tugged his chin up toward me. “It’s only a dream, friend,” I told him. “But I can make you hurt until you die of the pain.” Not true, exactly, but "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("she")]), _vm._v(" certainly could.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He got some coherent words out. “She’s not yours!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So now you own the night mind?” I set the Smitty against his temple.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No! You don’t understand!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Listen.” I leaned in close, practically kissing his ear. “You’re snow leopard bait in here. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("She")]), _vm._v(" can make every sleeping moment of your life screaming hell, until you pull the trigger yourself to get out of it. And then you’ll just wake up screaming again, over and over and over and fucking over. So what I want is the God damned plane and a safe conduct out of here. You call off your dogs, we all go away, including "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("her,")]), _vm._v(" and that’s it. Done.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’ll never happen,” he gasped, gritting his teeth. Hannaday smelled like a corpse already, shit and old meat. “Thing is, she dropped out of orbit. But she never went up in the first place, Allen. She "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("came")]), _vm._v(" from up there.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I shot him in the temple, then said, “Wake up,” in the voices of a dozen screaming GIs in a burning helicopter.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("There was no Becque this time, but the camp was empty. I nosed into a couple of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("gers")]), _vm._v(". Everybody’s gear was here, just not their personal selves.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Antonov was parked by the windsock, both engines intact.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was daylight. I couldn’t check the stars, but I didn’t really need to. This was real life, whatever that meant these days. I took my Stinger rack and headed out toward the plane.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spacegirl sat on the lowest rung of the ladder, huddled in her Russian flight suit.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s true, isn’t it?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’ll own us all.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Another shrug.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re the weirdest alien invasion in history. What do you "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("want")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She glanced up at the sky, her eyes flashing the brightness of the sun for one moment.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Can’t help you there,” I said. “But if you’re tired of being a weapon, I can help you with that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Spacegirl smiled. A real smile this time, not her killing smile.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Go to sleep,” I told my fellow mercs, the pilot, Hannaday, anyone left alive within miles of us, in the voices of a million brilliant suns.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("We hid the BJC jeep under a tarp I’d taken from the camp’s fuel dump. The vehicle had gotten us into the mountains far to the south before running out of gas. The camp wasn’t visible to the naked eye from here, but I’d spotted the Antonov beating its way into the morning sky, then northeast toward Ulan Bator.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Perhaps an hour later, a massive flight of helicopters came to salvage the American dead. While the big boys dusted off wreckage and bodies, Blackhawks chewed up a huge patch of desert where the camp must have been.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By noon, nothing remained but smoke, the spacegirl, and me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We walked farther into the mountains, until my legs couldn’t take it anymore. I found a hollow in one of the canyons and pitched a little tent.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Come in with me,” I told her, “and let’s dream of your home. We won’t come back this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The grenades I wired for our pillows were lumpy. Still fell asleep, her tight in my arms as any lover I’d ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Somehow, I could smell Nichols’s Paki horse turds even as spacegirl took my hand and led me across the clouds of a distant, brilliant heaven.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f166d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/lastplane.vue
// module id = 72
// module chunks = 0